<template>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M0.105548 4.55276C0.352537 4.05878 0.95321 3.85856 1.44719 4.10555L5.99997 6.38194L10.5528 4.10555C11.0467 3.85856 11.6474 4.05878 11.8944 4.55276C12.1414 5.04674 11.9412 5.64741 11.4472 5.8944L5.99997 8.61801L0.552761 5.8944C0.0587828 5.64741 -0.141442 5.04674 0.105548 4.55276Z"
    fill="currentColor"
  />
</template>
